export const SET_SECONDARY_STATE = "SET_SECONDARY_STATE";

export const RESET_SECONDARY_STATE = "RESET_SECONDARY_STATE";